import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Collapse, Navbar, NavbarBrand, NavLink, NavbarToggler } from 'reactstrap';
import logo from '../images/LogoHeader.png';
import NavMenuSignedIn from './NavMenuSignedIn';
import * as Localizer from '../store/Localization';
import * as paths from '../data/Paths';
import './NavMenu.css';

class NavMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };

        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        this.props.localizerDispatch.getAllStrings();
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        const accountsState = this.props.accountsState;
        const showNav = (
            accountsState.authenticated &&
            accountsState.authenticatedPrivacyAccepted
        );

        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm">
                    <NavbarBrand tag={Link} to={paths.home}>
                        <img alt="HCS Logo" className="logo-header" src={logo} />
                        {this.props.localizerState.appTitle}
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggle} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                        <ul className="navbar-nav flex-grow">
                            {showNav ? <NavMenuSignedIn /> : <NavLink href={paths.about}>About</NavLink>}
                        </ul>
                    </Collapse>
                </Navbar>
            </header>
        );
    }
}

export default connect(
    state => ({
        accountsState: state.accounts,
        localizerState: state.localizer
    }),
    dispatch => ({
        localizerDispatch: bindActionCreators(Localizer.actionCreators, dispatch)
    })
)(NavMenu);



// WEBPACK FOOTER //
// ./src/components/NavMenu.js